import React from 'react'
import { LoaderContainer } from 'components/Loading/styles'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { GlobalReducer } from 'types/global'
/**
 * Componente global para loading na aplicação
 * @param param0 
 */
const Loading: React.FC<any> = ({ children, ...rest }) => {
    /**
     * Utilizo um reducer global para suportar loading de qualquer página
     */
    const globalSelector: GlobalReducer = useSelector(
        (state: RootReducerState) => state.globalReducers
    )

    return (
        <>
            <LoaderContainer active={globalSelector.loading} data-testid={`loading`}>
                <img src={`/loader-branco.gif`} />
            </LoaderContainer>
        </>
    )
}

export default Loading